import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=7a4bef0c&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4bef0c",
  null
  
)

export default component.exports